import _classCallCheck from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/gitlab-runner/builds/c6Ly8Yoi/0/kgsports/kgsport-cms-intl/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { UserInfo } from "../api";
import "../common";
import { BaseResource } from "@kgsport-cms/common";
export var UserInfoService = /*#__PURE__*/function (_BaseResource) {
  _inherits(UserInfoService, _BaseResource);
  var _super = _createSuper(UserInfoService);
  function UserInfoService() {
    _classCallCheck(this, UserInfoService);
    return _super.apply(this, arguments);
  }
  _createClass(UserInfoService, [{
    key: "userInfo",
    value: function userInfo() {
      return this.requester.get(UserInfo.info);
    }
  }, {
    key: "editUser",
    value: function editUser(data) {
      return this.requester.post(UserInfo.update, data);
    }
  }, {
    key: "bindPhone",
    value: function bindPhone(data) {
      return this.requester.post(UserInfo.updatePhone, data);
    }
  }, {
    key: "updatePassword",
    value: function updatePassword(data) {
      return this.requester.post(UserInfo.updatePassword, data);
    }
  }, {
    key: "updateWithdrawPwd",
    value: function updateWithdrawPwd(data) {
      return this.requester.post(UserInfo.updateWithdrawPwd, data);
    }
  }, {
    key: "protectWithdraw",
    value: function protectWithdraw(data) {
      return this.requester.post(UserInfo.protectWithdraw, data);
    }
  }, {
    key: "getPhoneNumber",
    value: function getPhoneNumber(params) {
      return this.requester.get(UserInfo.getPhoneNumber, {
        params
      });
    }
  }, {
    key: "getSmsCode",
    value: function getSmsCode(params) {
      return this.requester.get(UserInfo.getSmsCode, {
        params
      });
    }
  }, {
    key: "getPhoneInfoCode",
    value: function getPhoneInfoCode(data) {
      return this.requester.post(UserInfo.getPhoneInfoCode, data);
    }
  }, {
    key: "platformBalance",
    value: function platformBalance(params) {
      // 获取所有游戏平台余额
      return this.requester.get(UserInfo.queryAllPlatformBalance, {
        timeout: 10 * 1000,
        params
      });
    }
  }, {
    key: "getWelfareList",
    value: function getWelfareList(params) {
      // 获取当前用户vip详情、福利、成长值
      return this.requester.get(UserInfo.getWelfareList, {
        params
      });
    }
  }, {
    key: "getVipInfo",
    value: function getVipInfo(params) {
      // 获取当前vip信息
      return this.requester.get(UserInfo.getVipInfo, {
        params
      });
    }
  }, {
    key: "getVipChangeInfo",
    value: function getVipChangeInfo(params) {
      // 获取我的成长值
      return this.requester.get(UserInfo.getVipChangeInfo, params);
    }
  }, {
    key: "vipSing",
    value: function vipSing() {
      // 签到
      return this.requester.post(UserInfo.vipSing);
    }
    // 获取福利列表
  }, {
    key: "getWealList",
    value: function getWealList(params) {
      return this.requester.get(UserInfo.getWealList, {
        params
      });
    }
    // 获取福利列表
  }, {
    key: "getWealGroup",
    value: function getWealGroup(params) {
      return this.requester.get(UserInfo.getWealGroup, {
        params
      });
    }
    // 获取未领取福利数量
  }, {
    key: "getWealCount",
    value: function getWealCount() {
      return this.requester.get(UserInfo.getWealCount);
    }
    // 领取福利
  }, {
    key: "receiveAward",
    value: function receiveAward(params) {
      return this.requester.post(UserInfo.receiveAward, params);
    }
    // 获取vip中心开关
  }, {
    key: "getVipOpenStatus",
    value: function getVipOpenStatus() {
      return this.requester.get(UserInfo.getVipOpenStatus);
    }
    // 金币兑换记录 api/user/coin/page
  }, {
    key: "getGoldChangeList",
    value: function getGoldChangeList(params) {
      return this.requester.get(UserInfo.getGoldChangeList, {
        params
      });
    }
    // 获取金币描述信息
  }, {
    key: "getGoldDesc",
    value: function getGoldDesc() {
      return this.requester.get(UserInfo.getGoldDesc);
    }
    //获取邮箱验证码
  }, {
    key: "getEmailVerifyCode",
    value: function getEmailVerifyCode(data) {
      return this.requester.post(UserInfo.getEmailVerifyCode, data);
    }
    // 玩家解绑第三方软件
  }, {
    key: "unbindThirdApp",
    value: function unbindThirdApp(data) {
      return this.requester.post(UserInfo.unbindThirdApp, data);
    }
    // 玩家绑定第三方软件
  }, {
    key: "bindThirdApp",
    value: function bindThirdApp(data) {
      return this.requester.post(UserInfo.bindThirdApp, data);
    }
  }]);
  return UserInfoService;
}(BaseResource);